function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { isSet } from "./isSet";
import { lookup } from "./lookup";
export function pluralize(i18n, count, scope, options) {
  options = Object.assign({}, options);
  var translations;
  var message;

  if (_typeof(scope) === "object" && scope) {
    translations = scope;
  } else {
    translations = lookup(i18n, scope, options);
  }

  if (!translations) {
    return i18n.missingTranslation.get(scope, options);
  }

  var pluralizer = i18n.pluralization.get(options.locale);
  var keys = pluralizer(i18n, count);

  while (keys.length) {
    var key = keys.shift();

    if (isSet(translations[key])) {
      message = translations[key];
      break;
    }
  }

  options.count = count;
  return i18n.interpolate(i18n, message, options);
}